import { ASSOCIATES_IP3_ACTIONS_TYPES } from './associates-ip3-reducer.constants'

export const associatesIP3Reducer = (state, { type, payload }) => {
  switch (type) {
    case ASSOCIATES_IP3_ACTIONS_TYPES.SET_TABLE_DATA:
      return {
        ...state,
        data: payload.data,
        search: payload.search,
        pagination: payload.pagination,
        loading: false,
        msLoaded: Date.now(),
      }
    case ASSOCIATES_IP3_ACTIONS_TYPES.ASSOCIATES_LOADING:
      return {
        ...state,
        error: false,
        loading: true,
      }
    case ASSOCIATES_IP3_ACTIONS_TYPES.ASSOCIATES_FAILURE:
      return {
        ...state,
        error: payload,
        loading: false,
        msLoaded: true,
      }
    case ASSOCIATES_IP3_ACTIONS_TYPES.UPDATE_ASSOCIATES:
      return {
        ...state,
        loading: false,
        data: state.data.map((item) => (item.id === payload.id ? { ...item, ...payload } : item)),
      }
    case ASSOCIATES_IP3_ACTIONS_TYPES.DELETE_ASSOCIATED:
      return {
        ...state,
        loading: false,
        data: state.data.filter((item) => item.id !== payload.id),
        pagination: {
          ...state.pagination,
          total_solicitudes: state.pagination.total_solicitudes - 1,
        },
      }
    default:
      throw new Error('unknown action')
  }
}
